import React from 'react';
import Icon from '../../../components/AppIcon';

const TrialModeNotice = () => {
  return (
    <div className="w-full bg-muted border border-border rounded-lg p-4 md:p-6">
      <div className="flex items-start gap-3">
        <div className="flex-shrink-0 w-10 h-10 rounded-lg bg-primary/10 flex items-center justify-center">
          <Icon name="Info" size={20} color="var(--color-primary)" />
        </div>
        <div className="flex-1 space-y-2">
          <h3 className="text-sm font-semibold text-foreground">
            7-Day Free Trial
          </h3>
          <p className="text-sm text-muted-foreground leading-relaxed">
            New accounts start with a 7-day free trial. After 7 days, your trip settings and inventory will be automatically deleted, but you can continue using GalleyPlan by creating a new trip for another 7-day cycle.
          </p>
          <div className="flex items-center gap-2 text-xs text-muted-foreground pt-1">
            <Icon name="Calendar" size={14} />
            <span>Upgrade to Premium for unlimited access and trips up to 60 days</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TrialModeNotice;